import React from 'react';

import { ClipboardContext } from '@/core/lib/clipboard/clipBoard.context';

const ClipboardProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <ClipboardContext.Provider
    value={{
      writeToClipboard: () => Promise.resolve(),
      readFromClipboard: () => Promise.resolve({ value: '', type: '' }),
    }}
  >
    {children}
  </ClipboardContext.Provider>
);

export default ClipboardProvider;
